import React from "react";
import ReactDom from "react-dom";
import "./Model.css"

export default function Model(props) {
    
     return  ReactDom.createPortal(<div className="model-container">
     <div className="head-model">
       <h2>Hi There</h2>
       <h3>Welcome to my portfolio!</h3>
     </div>
     <div className="middle-model">
       <p>My name is Prashank and I am Software Engineer by profession. I love to build things. Please browse through my portfolio in order to know more.</p>
       <p>Thank you!!</p>
     </div>
     <div className="end-model">
         <button onClick={props.onclose} className="mybutton red">Close</button>
     </div>
   </div>,document.getElementById("model"));

}